require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./sub-fire-2-mobile.json") })
        }
      }, "path---sub-fire-2-mobile");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---sub-fire-2-mobile!./.cache/json/sub-fire-2-mobile.json
// module id = 363
// module chunks = 231608221292675